import React, { useEffect, useMemo, useState } from "react";
import { Card, Tabs, Collapse, Tag, Space, Button, Radio } from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "antd/dist/reset.css"; // optional if you're using Ant Design v5 styles
import { useSelector } from "react-redux";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import MeterStatusView from "./MeterStatusView";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { calculateDateRangeFromDate } from "../../../../../../Utils/DateConverstion";

const { TabPane } = Tabs;
const { Panel } = Collapse;

const StatusView = () => {
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  const { makeRequest } = useStoreUpdaterWithAPI();
  console.log(color);
  const { isdarkMode } = mode;
  const [open, setOpen] = useState(false);
  const [cardData, setcardData] = useState([
    {
      statusID: 1,
      statusName: "Coverters",
      totalCount: 0,
      liveCount: 0,
      offCount: 0,
    },
    {
      statusID: 2,
      statusName: "Device",
      totalCount: 0,
      liveCount: 0,
      offCount: 0,
    },
  ]);
  const [deviceStatus, setDeviceStatus] = useState([]);
  const [groupStatus, setGroupStatus] = useState([]);
  const [rowDeviceData,setRowDeviceData]= useState([])
  const [rowGroupData,setRowGroupData]= useState([])
  const [parameters,setParameters]=useState([])
  const [activeTab, setActiveTab] = useState("1");
  const [activeKey, setActiveKey] = useState(null);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };


   const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setRefetch(prev => !prev); // Toggle to trigger effect
    }, 60000);
 
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  console.log(refetch)

  const getGroupStatusData = () => {
    // console.log();
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_GROUP_DEVICE_STATUS}?timespan=5`,
    }).then((res) => {
      console.log("Master details :", res);
      if (res) {
        setGroupStatus(res);
      }
    });
  };
  const getDeviceStatusData = () => {
    // console.log();
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONVERTER_DEVICE_STATUS}?timespan=5`,
    }).then((res) => {
      console.log("Master details :", res);
      if (res) {
        setDeviceStatus(res);
      }
    });
  };
  const getStatusData = () => {
    // console.log();
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONVERTER_AND_DEVICE_STATUS}?timespan=5`,
    }).then((res) => {
      console.log("Master details :", res);
      if (res) {
        setcardData(res);
      }
    });
  };
  useEffect(() => {
    getStatusData();
    console.log(activeTab)
    const deviceItem=localStorage.getItem('deviceItem');
    // const deviceItem=JSON?.parse(localStorage.getItem('deviceItem'));
    console.log(deviceItem)
    if(deviceItem!=''){
      console.log(JSON.parse(deviceItem))

    }
    if(activeTab==1){ 
      getDeviceStatusData();
      if (deviceItem!=''&&deviceItem!=null) { 
        handleRowClick(JSON.parse(deviceItem))
      }
    } 
    if(activeTab==2){ 
      getGroupStatusData()
      if (deviceItem!=''&&deviceItem!=null) {
        handleRowClick(JSON.parse(deviceItem))
      }
    } 
  }, [refetch,activeTab]);

  const deviceData = [
    {
      deviceName: "Device 1",
      active: 20,
      inactive: 25,
      alarms: 2,
      data: [
        {
          id: 1,
          subgroup: 1,
          name: "EB IN",
          status: "Load",
          v: 545.43,
          i: 545.43,
          kw: 545.43,
          pf: 545.43,
          alarms: "01",
          lastComm: "10-02-2025 12:32",
        },
        {
          id: 2,
          subgroup: 1,
          name: "DG IN",
          status: "Load",
          v: 655.75,
          i: 655.75,
          kw: 655.75,
          pf: 655.75,
          alarms: "-",
          lastComm: "10-02-2025 12:32",
        },
        {
          id: 3,
          subgroup: 1,
          name: "Solar",
          status: "Load",
          v: 656.65,
          i: 656.65,
          kw: 656.65,
          pf: 656.65,
          alarms: "03",
          lastComm: "10-02-2025 12:32",
        },
        {
          id: 4,
          subgroup: 2,
          name: "Mill",
          status: "Idle",
          v: 436.76,
          i: 436.76,
          kw: 436.76,
          pf: 436.76,
          alarms: "-",
          lastComm: "10-02-2025 12:32",
        },
        {
          id: 5,
          subgroup: 2,
          name: "MLSB",
          status: "Off",
          v: "-",
          i: "-",
          kw: "-",
          pf: 658.65,
          alarms: "-",
          lastComm: "10-02-2025 12:32",
        },
      ],
    },
    // {
    //   deviceName: "Device 2",
    //   active: 16,
    //   inactive: 12,
    //   alarms: 3,
    //   data: [],
    // },
    // {
    //   deviceName: "Device 3",
    //   active: 32,
    //   inactive: 33,
    //   alarms: 6,
    //   data: [],
    // },
  ];

  const getStatusTag = (status) => {
    console.log(status)
    switch (status) {
      case "ON":
        return <Tag color="green">On</Tag>;
      case "idle":
        return <Tag color="orange">Idle</Tag>;
      case "OFF":
        return <Tag color="red">Off</Tag>;
      default:
        return <Tag>{status}</Tag>;
    }
  };

  const deviceColumnDefs = useMemo(
    () => [
      // {
      //   headerName: "Subgroup",
      //   field: "subgroup",
      //   width: 100,
      //   rowSpan: (params) => {
      //     const currentIndex = params.node.rowIndex;
      //     const currentSubgroup = params.data?.subgroup;
      //     const api = params.api;

      //     // Only calculate span if this is the first occurrence
      //     const previousRow = api.getDisplayedRowAtIndex(currentIndex - 1);
      //     if (previousRow?.data?.subgroup === currentSubgroup) return 0;

      //     // Count how many consecutive rows have the same subgroup
      //     let span = 1;
      //     for (let i = currentIndex + 1; i < api.getDisplayedRowCount(); i++) {
      //       const nextRow = api.getDisplayedRowAtIndex(i);
      //       if (nextRow?.data?.subgroup === currentSubgroup) {
      //         span++;
      //       } else {
      //         break;
      //       }
      //     }
      //     return span;
      //   },
      //   cellClass: "subgroup-cell",
      //   suppressMovable: true,
      // },
      { headerName: "Device ID", field: "meterid", width: 80,flex:1 },
      { headerName: "Device Name", field: "metername", width: 130 ,flex:1},
      {
        headerName: "Status",
        field: "meterStatus",
        width: 100,
        flex:1,
        cellRenderer: ({ value }) => getStatusTag(value),
      },
      { headerName: "VLL", field: "vllAvg", width: 110,flex:1 },
      { headerName: "I Avg", field: "iavg", width: 110 ,flex:1},
      { headerName: "kWT", field: "kwt", width: 110,flex:1 },
      { headerName: "kVAT", field: "kvat", width: 110 ,flex:1},
      { headerName: "PFT", field: "pft", width: 110,flex:1 },
      { headerName: "New Alarms", field: "alarms", width: 110 ,flex:1},
      { headerName: "Last Comm.", field: "createdon", flex: 1 },
    ],
    []
  );
  const groupColumnDefs = useMemo(
    () => [
    {
  headerName: "Subgroup",
  field: "subGroupID", // Use consistent field name
  width: 100,
  rowSpan: (params) => {
    const currentIndex = params.node.rowIndex;
    const currentSubgroup = params.data?.subGroupID;
    console.log(currentSubgroup) 
    const api = params.api;

    // Only calculate span if this is the first occurrence
    const previousRow = api.getDisplayedRowAtIndex(currentIndex - 1);
    if (previousRow?.data?.subGroupID === currentSubgroup) return 0;

    // Count how many consecutive rows have the same subgroup
    let span = 1;
    for (let i = currentIndex + 1; i < api.getDisplayedRowCount(); i++) {
      const nextRow = api.getDisplayedRowAtIndex(i);
      if (nextRow?.data?.subGroupID === currentSubgroup) {
        span++;
      } else {
        break;
      }
    }
    return span;
  },
  cellClass: "subgroup-cell",
  suppressMovable: true,
},
      { headerName: "Device ID", field: "meterid", width: 80,flex:1 },
      { headerName: "Device Name", field: "metername", width: 130 ,flex:1},
      {
        headerName: "Status",
        field: "meterStatus",
        width: 100,
        flex:1,
        cellRenderer: ({ value }) => getStatusTag(value),
      },
      { headerName: "VLL", field: "vllAvg", width: 110,flex:1 },
      { headerName: "I Avg", field: "iavg", width: 110 ,flex:1},
      { headerName: "kWT", field: "kwt", width: 110,flex:1 },
      { headerName: "kVAT", field: "kvat", width: 110 ,flex:1},
      { headerName: "PFT", field: "pft", width: 110,flex:1 },
      { headerName: "New Alarms", field: "alarms", width: 110 ,flex:1},
      { headerName: "Last Comm.", field: "createdon", flex: 1 },
    ],
    []
  );

  const handleParameters =(event)=>{
    console.log(event.data)
    setParameters(event?.data)
    setOpen(true)
  }

  const handleRowClick = (data) => {
    console.log("Row clicked:", data);
    console.log(activeTab)
     const currentDate = new Date();
        console.log(currentDate);
        const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
        console.log(from, to);
     makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONVERTER_DEVICE_DETAILS}?SectionID=${activeTab==1?1:2}&ConverterorGroupID=${data.converterID|| data.groupID}&FromDate=${from}&ToDate=${to}`,
    }).then((res) => {
      console.log("Master details :", res);
      if (res!=null) {
        setRowDeviceData(res);
      }
    });
  };
  
  console.log(cardData);
  console.log(deviceStatus);

  const handleCollapseChange = (key, deviceItem) => {
    if(key!=activeKey){
      setActiveKey(key);
      console.log(deviceItem)
      localStorage.setItem("deviceItem",JSON.stringify(deviceItem))
      handleRowClick(deviceItem);
      console.log("Expanded panel index:", key);
    }else{
      setActiveKey(null);
      localStorage.setItem("deviceItem",JSON.stringify({}))
    }
  };
  console.log(parameters)
  return (
    <div className="p-4">
      <div className="">
        <h1 className="text-2xl font-semibold mb-4">Status View</h1>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-6">
        {cardData.map((card, i) => (
          <Card key={i} className="rounded-xl" bodyStyle={{ padding: 0 }}>
            <div className="flex justify-between items-center bg-green-200 p-5 rounded-xl">
              <div>
                <div className="text-black text-md">{card.statusName}</div>
                <div className="text-xl font-bold ">
                  {card.totalCount.toString().padStart(2, "0")}
                </div>
              </div>
              <span className="border-r-2 h-10 border-gray rounded-xl" />
              <div className="">
                <div className="text-black ">Active</div>
                <div className="text-green-600 text-xl font-bold">
                  {" "}
                  {card.liveCount.toString().padStart(2, "0")}
                </div>
              </div>
              <span className="border-r-2 h-10 border-gray rounded-xl" />
              <div className="">
                <div className="text-black ">Inactive</div>
                <div className="text-red-600 text-xl font-bold">
                  {" "}
                  {card.offCount.toString().padStart(2, "0")}
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <Radio.Group
        value={activeTab}
        onChange={(e) => {
          
          setActiveKey(null)
          setActiveTab(e.target.value)}}
        style={{ marginBottom: 16 }}
      >
        <Radio.Button value="1">Area Wise</Radio.Button>
        <Radio.Button value="2">Group Wise</Radio.Button>
      </Radio.Group>
      {activeTab == "1" && (
        <div className="flex-col gap-4 flex ">
          {deviceStatus &&
            deviceStatus.map((device, i) => (
              <Collapse
               accordion
            activeKey={activeKey}
            onChange={() => handleCollapseChange(i, device)}
            key={i}
                className={` ${device.activeDevice? 'border-l-green-500':'border-l-red-500'} border-l-4 border-y-0 rounded-md  custom-collapse`}
                bodyStyle={{ padding: 0 }}
              >
                <Panel
                  className={`    rounded-t-xl ${isdarkMode ? "dark-collapse" : "light-collapse"}`}
                  header={
                    <div className="flex justify-between items-center">
                      <span className="min-w-[100px]">
                        {device.converterName}
                      </span>
                      <Tag className="border-0 p-1 px-2" color="green">
                        ✔ Active {device.activeDevice}
                      </Tag>
                      <Tag className="border-0 p-1 px-2" color="red">
                        ✘ Inactive {device.inActiveDevice}
                      </Tag>
                      <Tag className="border-0 p-1 px-2" color="purple">
                        🔔 Alarm {device.alarm}
                      </Tag>
                    </div>
                  }
                  key={i}
                  bodyStyle={{ padding: 0 }}
                >
                  <div  className={` ${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"} cursor-pointer`}
            style={{
              '--ag-header-background-color': color.themeConfig.colorPrimary,
              '--ag-header-foreground-color': '#fff',
              '--ag-header-group-bg': color.themeConfig.colorPrimaryShade, // custom var
              height: "300px", width: "100%", overflowY: "auto"
            }}>
                      <AgGridReact 
                        suppressRowTransform={true} 
                        rowData={rowDeviceData} domLayout="normal" columnDefs={deviceColumnDefs}
                        onRowClicked={handleParameters}  className="mt-2"/>
                    </div>
                </Panel>
              </Collapse>
            ))}
        </div>
      )}
      {activeTab == "2" && (
        <div className="flex-col gap-4 flex ">
           {groupStatus &&
            groupStatus.map((device, i) => (
              <Collapse
                  accordion
            activeKey={activeKey}
            onChange={() => handleCollapseChange(i, device)}
            key={i}
  className={` ${device.activeDevice? 'border-l-green-500':'border-l-red-500'} border-l-4 border-y-0 rounded-md  custom-collapse`}
                  bodyStyle={{ padding: 0 }}
              >
                <Panel
                  className={`    rounded-t-xl ${isdarkMode ? "dark-collapse" : "light-collapse"}`}
                  header={
                    <div className="flex justify-between items-center">
                      <span className="min-w-[100px]">
                        {device.groupName}
                      </span>
                      <Tag className="border-0 p-1 px-2" color="green">
                        ✔ Active {device.activeDevice}
                      </Tag>
                      <Tag className="border-0 p-1 px-2" color="red">
                        ✘ Inactive {device.inActiveDevice}
                      </Tag>
                      <Tag className="border-0 p-1 px-2" color="purple">
                        🔔 Alarm {device.alarm}
                      </Tag>
                    </div>
                  }
                  key={i}
                  bodyStyle={{ padding: 0 }}
                >
                  <div  className={` ${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"} cursor-pointer`}
            style={{
              '--ag-header-background-color': color.themeConfig.colorPrimary,
              '--ag-header-foreground-color': '#fff',
              '--ag-header-group-bg': color.themeConfig.colorPrimaryShade, // custom var
              height: "300px", width: "100%", overflowY: "auto"
            }}>
                      <AgGridReact 
                        suppressRowTransform={true} 
                        rowData={rowDeviceData} domLayout="normal" columnDefs={groupColumnDefs}
                        onRowClicked={handleParameters}  className="mt-2"/>
                    </div>
                </Panel> 
              </Collapse>
            ))}
    
          {/* <Collapse
            defaultActiveKey={["4"]}
            className="border-l-4 rounded-md border-l-red-500 custom-collapse"
            bodyStyle={{ padding: 0 }}
          >
            {deviceData.map((device, index) => (
              <Panel
                className={`   rounded-t-xl ${isdarkMode ? "dark-collapse" : "light-collapse"}`}
                header={
                  <Space className="flex justify-between items-center">
                    <span>{device.deviceName}</span>
                    <Tag className="border-0 p-1 px-2" color="green">
                      ✔ Active {device.active}
                    </Tag>
                    <Tag className="border-0 p-1 px-2" color="red">
                      ✘ Inactive {device.inactive}
                    </Tag>
                    <Tag className="border-0 p-1 px-2" color="purple">
                      🔔 Alarm {device.alarms}
                    </Tag>
                  </Space>
                }
                key={index}
                bodyStyle={{ padding: 0 }}
              >
                <div
                  className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
                  style={{
                    "--ag-header-background-color":
                      color.themeConfig.colorPrimary,
                    "--ag-header-foreground-color": "#fff",
                    "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                    height: "80vh",
                    width: "100%",
                    overflowY: "auto",
                  }}
                >
                  <AgGridReact rowData={device.data} columnDefs={columnDefs} />
                </div>
              </Panel>
            ))}
          </Collapse> */}
        </div>
      )}

      {/* </Tabs> */}
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
        width={"80%"}
      >
        <div className="flex flex-col gap-6 mt-2">
          <div>
            <MeterStatusView parameters={parameters}  />
          </div>

          {/* <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
          <Button onClick={onClose} className="">
            Cancel
          </Button>
          <Button
            type="primary"
            // disabled={!alertName.trim()}
            // onClick={handleAdd}
          >
            Add
          </Button>
        </div> */}
        </div>
      </CustomThemeDrawer>
    </div>
  );
};

export default StatusView;
